<template>
  <div>
    <div class="navigation">
      <div class="navigation_bottom">
        <img class="ai_assistant" ref="ai_assistant"
          src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/AI_Ass/AI_Ass.png" alt="">
        <span ref="scroll_bottom" class="scroll_bottom iconfont" @click="scrollToBottom">&#xe685; 回到底部</span>
      </div>
      <div class="navigation_items" ref="navigation_items">
        <div class="main_input" ref="main_input">
          <!-- 视频上传区域 -->
          <div class="upload-section" @click="handleVideoUpload">
            <div v-if="!uploadVideo" class="upload-placeholder">
              <span class="upload-plus">+</span>
              <span class="upload-label">上传视频</span>
            </div>
            <div v-else class="uploaded-preview">
              <img :src="videoThumbnail" alt="视频缩略图" class="thumbnail-img">
              <div class="remove-btn" @click.stop="removeVideo">×</div>
            </div>
          </div>

          <!-- 输入框 -->
          <textarea name="" id="" placeholder="请描述你想要的音效风格，例如：欢快的背景音乐、自然环境音效、电影级配乐..."
            v-model="textarea"
            @focus="handleTextareaFocus"
            @input="handleTextareaInput"
            @blur="handleTextareaBlur"
            @click="handleTextareaClick"
            :disabled="processing"></textarea>
          <button ref="up" class="sent iconfont" :class="{ 'has_input': canSend }" @click.stop="startTask" v-show="!scrollStatus" :disabled="!canSend || processing">
            <span v-if="!processing">&#xe688;</span>
            <span v-else class="rotating">&#xe6a4;</span>
          </button>
        </div>
        <!-- 放大后的发送按钮（绝对定位） -->
        <button ref="down" class="sent_expanded iconfont" :class="{ 'has_input': canSend }" @click.stop="startTask" v-show="scrollStatus" :disabled="!canSend || processing">
          <span v-if="!processing">&#xe688;</span>
          <span v-else class="rotating">&#xe6a4;</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { getOssClient } from '@/utils/oss'
import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/promptVideo'
import { genOssImage } from '@/utils/ossPath'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiVideoRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import { getTaskEnd, getTaskStart } from '@/api/user'
import { VIDEO_SOUND } from '@/enums/common/modules'
import videoSoundWorkflow from '@/api/json_api/视频音效.json'

import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET } from '@/utils/secretCrypto'
export default {
  name: 'NaviGation_VideoSound',
  props: {
    initialChatHistory: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      textarea: '',
      uploadVideo: '', // 上传的视频URL
      videoThumbnail: '', // 视频缩略图
      processing: false,
      videoSoundChatHistory: [],
      scrollStatus: false,
      // WebSocket
      ws: null,
      clientId: '',
      // 防止重复获取文件标志
      fileFetched: false,
      // 任务日志ID
      taskLogId: null,
      // OSS 配置
      ossConfig: {
        accessKeyId: OSS_ACCESS_KEY_ID,
        accessKeySecret: OSS_ACCESS_KEY_SECRET
      },
      // 节点名称映射 - 根据视频音效工作流实际节点
      nodeNameMap: {
        149: 'Load video file',
        161: 'Video info extraction',
        72: 'MMAudio FeatureUtilsLoader',
        73: 'MMAudio ModelLoader',
        107: 'MMAudio Sampler',
        154: 'Merge audio & upload'
      },
      currentExecutingNode: '' // 当前执行的节点名称
    }
  },
  computed: {
    canSend() {
      return this.textarea.trim() !== '' && this.uploadVideo !== ''
    }
  },
  created() {
    if (this.initialChatHistory && this.initialChatHistory.length > 0) {
      this.videoSoundChatHistory = [...this.initialChatHistory]
    }
    // 从 sessionStorage 读取传递的提示词
    const savedPrompt = sessionStorage.getItem('video_sound_prompt')
    if (savedPrompt) {
      this.$nextTick(() => {
        this.textarea = savedPrompt
        console.log('从提示词优化页面传入的提示词:', savedPrompt)
        sessionStorage.removeItem('video_sound_prompt')
      })
    }
  },
  mounted() {
    // 点击外部关闭下拉菜单
    document.addEventListener('click', this.closeAllMenus)
    // 监听重新生成事件
    this.$root.$on('video-sound-regenerate', this.handleRegenerateFromParent)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeAllMenus)
    // 移除事件监听
    this.$root.$off('video-sound-regenerate', this.handleRegenerateFromParent)
  },
  methods: {
    // 处理视频上传
    handleVideoUpload() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'video/*'
      input.onchange = async (event) => {
        const file = event.target.files[0]
        if (file) {
          await this.processVideo(file)
        }
      }
      input.click()
    },

    // 处理视频文件
    async processVideo(file) {
      try {
        Message.info('正在上传视频...')

        // 生成视频缩略图
        await this.generateVideoThumbnail(file)

        const ossClient = await getOssClient()
        const tmp = '/input/'
        const fileName = `video_sound_${Date.now()}_${file.name}`
        const result = await ossClient.put(tmp + fileName, file)

        console.log('OSS上传结果:', result)

        if (result.name) {
          const videoUrl = `https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/${result.name}`
          console.log('生成的视频URL:', videoUrl)

          this.uploadVideo = videoUrl
          Message.success('视频上传成功!')
        } else {
          Message.error('视频上传失败，请重试!')
        }
      } catch (error) {
        console.error('上传视频失败:', error)
        Message.error('视频上传失败，请检查网络!')
      }
    },

    // 生成视频缩略图
    async generateVideoThumbnail(file) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        video.preload = 'metadata'
        video.src = URL.createObjectURL(file)

        video.onloadedmetadata = () => {
          video.currentTime = Math.min(1, video.duration / 2)
        }

        video.onseeked = () => {
          canvas.width = video.videoWidth
          canvas.height = video.videoHeight
          context.drawImage(video, 0, 0, canvas.width, canvas.height)
          this.videoThumbnail = canvas.toDataURL('image/jpeg', 0.8)
          URL.revokeObjectURL(video.src)
          resolve()
        }

        video.onerror = () => {
          console.error('视频加载失败')
          URL.revokeObjectURL(video.src)
          reject(new Error('视频加载失败'))
        }
      })
    },

    // 移除视频
    removeVideo() {
      this.uploadVideo = ''
      this.videoThumbnail = ''
    },

    // 关闭所有下拉菜单
    closeAllMenus() {
      // 预留接口
    },

    // 处理来自父组件的重新生成请求
    handleRegenerateFromParent(regenerateData) {
      if (!regenerateData) return
      console.log('接收到重新生成请求:', regenerateData)
      this.textarea = regenerateData.content
      this.uploadVideo = regenerateData.video
      this.videoThumbnail = regenerateData.videoThumbnail
      sessionStorage.removeItem('video_sound_regenerate')
      this.$nextTick(() => {
        this.startTask()
      })
    },

    // 处理 textarea 获得焦点
    handleTextareaFocus() {
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },
    // 处理 textarea 输入
    handleTextareaInput() {
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },
    // 处理 textarea 失去焦点
    handleTextareaBlur() {
      // 不做任何处理，保持当前状态
    },
    // 处理 textarea 点击
    handleTextareaClick() {
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },
    // 导航栏状态
    handleScroll(val) {
      if (val) {
        if (this.$refs.navigation_items) {
          this.$refs.navigation_items.style.width = '70%'
        }
        if (this.$refs.ai_assistant) this.$refs.ai_assistant.style.opacity = 1
        if (this.$refs.scroll_bottom) this.$refs.scroll_bottom.style.opacity = 1
        this.scrollStatus = true
      } else {
        if (this.$refs.navigation_items) {
          this.$refs.navigation_items.style.width = '60%'
        }
        if (this.$refs.ai_assistant) this.$refs.ai_assistant.style.opacity = 0
        if (this.$refs.scroll_bottom) this.$refs.scroll_bottom.style.opacity = 0
        this.scrollStatus = false
      }
    },
    // 回滚到底部
    scrollToBottom() {
      if (this.scrollStatus) {
        this.$emit('scrollToBottom')
      }
    },

    // 替换工作流中的动态变量
    replaceWorkflowVariables(workflow, seed, videoUrl, userPrompt) {
      const workflowCopy = JSON.parse(JSON.stringify(workflow))
      console.log('🔍 开始替换工作流变量...')
      console.log('参数:', { seed, videoUrl, userPrompt })

      // 生成动态文件名（必须是JSON数组格式的字符串）
      const timestamp = Date.now()
      const randomNum = Math.floor(Math.random() * 99999)
      const outputFilename = `["tmp-comfyui/video/video-sound-${timestamp}_${randomNum}.mp4"]`
      console.log('📄 生成的文件名:', outputFilename)

      // 遍历所有节点替换变量
      for (const nodeId in workflowCopy) {
        const node = workflowCopy[nodeId]
        if (node.inputs) {
          for (const inputKey in node.inputs) {
            const inputValue = node.inputs[inputKey]
            if (typeof inputValue === 'string') {
              if (inputValue.includes('{{SEED}}')) {
                // 种子替换为数字类型
                node.inputs[inputKey] = seed
                console.log(`✅ 节点${nodeId}.${inputKey}: {{SEED}} -> ${seed}`)
              } else if (inputValue.includes('{{VIDEO_URL}}')) {
                node.inputs[inputKey] = videoUrl
                console.log(`✅ 节点${nodeId}.${inputKey}: {{VIDEO_URL}} -> ${videoUrl}`)
              } else if (inputValue.includes('{{USER_PROMPT}}')) {
                node.inputs[inputKey] = inputValue.replace('{{USER_PROMPT}}', userPrompt)
                console.log(`✅ 节点${nodeId}.${inputKey}: {{USER_PROMPT}} -> ${userPrompt}`)
              } else if (inputValue.includes('{{OUTPUT_FILENAME}}')) {
                node.inputs[inputKey] = outputFilename
                console.log(`✅ 节点${nodeId}.${inputKey}: {{OUTPUT_FILENAME}} -> ${outputFilename}`)
              } else if (inputValue.includes('{{OSS_ACCESS_KEY_ID}}')) {
                node.inputs[inputKey] = this.ossConfig.accessKeyId
                console.log(`✅ 节点${nodeId}.${inputKey}: {{OSS_ACCESS_KEY_ID}} -> ${this.ossConfig.accessKeyId}`)
              } else if (inputValue.includes('{{OSS_ACCESS_KEY_SECRET}}')) {
                node.inputs[inputKey] = this.ossConfig.accessKeySecret
                console.log(`✅ 节点${nodeId}.${inputKey}: {{OSS_ACCESS_KEY_SECRET}} -> [已隐藏]`)
              }
            }
          }
        }
      }

      console.log('🔍 替换后的工作流:', JSON.stringify(workflowCopy, null, 2))
      return workflowCopy
    },

    // 开始任务
    async startTask() {
      if (!this.canSend || this.processing) {
        return
      }

      // 确保放大状态
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }

      if (!this.uploadVideo) {
        Message.warning('请先上传视频!')
        return
      }

      if (this.textarea.trim() === '') {
        Message.warning('请输入音效描述!')
        return
      }

      const userMessage = this.textarea
      const userVideo = this.uploadVideo
      const userVideoThumbnail = this.videoThumbnail

      // 清空输入
      this.textarea = ''
      this.uploadVideo = ''
      this.videoThumbnail = ''

      // 添加用户消息到历史
      this.videoSoundChatHistory.push({
        role: 'user',
        content: userMessage,
        video: userVideo,
        videoThumbnail: userVideoThumbnail,
        timestamp: new Date().toISOString()
      })

      // 更新界面
      this.$emit('chatUpdate', this.videoSoundChatHistory)
      this.$emit('aiTyping', true)

      this.processing = true

      // 清空 textarea 后立即强制保持放大状态
      this.$nextTick(() => {
        this.handleScroll(true)
      })

      try {
        console.log('🎬 视频音效任务开始...')
        console.log('📝 提示词:', userMessage)
        console.log('🎬 视频URL:', userVideo)

        // 生成随机种子(Woosh节点最大支持4294967295)
        const seed = Math.floor(Math.random() * 4294967295)
        console.log('🎲 生成的种子:', seed)

        // 替换工作流变量
        const promptData = this.replaceWorkflowVariables(
          videoSoundWorkflow,
          seed,
          userVideo,
          userMessage
        )

        console.log('👍 工作流替换完成')

        // 打印关键节点，确认变量替换正确
        console.log('🔍 54号节点(视频URL):', JSON.stringify(promptData['54'], null, 2))
        console.log('🔍 38号节点(Woosh采样器):', JSON.stringify(promptData['38'], null, 2))
        console.log('🔍 53号节点(OSS上传):', JSON.stringify(promptData['53'], null, 2))

        this.clientId = uuidv4()
        const data = {
          prompt: promptData,
          client_id: this.clientId
        }

        console.log('🚀 准备发送视频音效任务...')
        console.log('📦 客户端ID:', this.clientId)
        console.log('📦 工作流节点数量:', Object.keys(promptData).length)

        // 发送 Prompt 请求
        const result = await genPrompt(data)

        console.log('📨 genPrompt 返回结果:', result)

        if (result && result.prompt_id) {
          console.log('✅ 任务提交成功，promptId:', result.prompt_id)
          // 监听 WebSocket 进度
          await this.listenToVideoSoundProgress(result.prompt_id, userMessage, userVideo)
        } else {
          throw new Error('任务提交失败')
        }
      } catch (error) {
        console.error('❗ 视频音效生成失败:', error)
        let errorMessage = '视频音效生成失败，请稍后再试!'
        if (error.response) {
          console.error('⚠️ 服务器返回错误:', error.response.status)
          errorMessage = `服务器错误: ${error.response.status}`
        } else if (error.message) {
          errorMessage = error.message
        }
        this.videoSoundChatHistory.push({
          role: 'assistant',
          content: '抱歉，似乎发生了某些问题',
          timestamp: new Date().toISOString(),
          isError: true
        })
        this.$emit('chatUpdate', this.videoSoundChatHistory)
        this.$emit('aiTyping', false)
        Message.error(errorMessage)
        this.processing = false
      }
    },

    // 监听视频音效生成进度
    // TODO: 等工作流就绪后启用，并根据实际节点调整 nodeNameMap
    async listenToVideoSoundProgress(promptId, taskPrompt, taskVideo) {
      this.fileFetched = false
      this.ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${this.clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时,请重新尝试!')
        this.ws.close()
      }, 2000)
      this.ws.onopen = () => {
        console.log('✅ WebSocket 连接成功')
        getTaskStart({
          type: VIDEO_SOUND,
          prompt: taskPrompt || '',
          input_images: taskVideo ? [taskVideo] : []
        }).then(rep => {
          this.taskLogId = rep.data.task.id
        })
        clearTimeout(wsTimeout)
      }
      this.ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(data)
            if (msg.type !== 'crystools.monitor') {
              console.log('📡 收到消息:', msg)
            }

            if (msg.type === 'executing') {
              const execData = msg.data
              if (execData.node === null && execData.prompt_id === promptId) {
                console.log('✅ 视频音效生成完成')
                this.currentExecutingNode = ''
                this.$emit('nodeUpdate', '')
                this.ws.close()
                if (!this.fileFetched) {
                  this.fileFetched = true
                  await this.fetchResultVideo(promptId)
                }
              } else if (execData.node !== null) {
                console.log(`🔄 正在执行节点: ${execData.node}`)
                const nodeName = this.nodeNameMap[execData.node] || `执行节点 ${execData.node}`
                this.currentExecutingNode = nodeName
                this.$emit('nodeUpdate', nodeName)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              console.log(`📈 进度: ${current}%`)
              this.$emit('progressUpdate', current)
            } else if (msg.type === 'status') {
              console.log('📊 状态更新:', msg.data)
              if (msg.data.status && msg.data.status.exec_info) {
                const execInfo = msg.data.status.exec_info
                if (execInfo.queue_remaining === 0) {
                  setTimeout(async () => {
                    await this.checkTaskStatus(promptId)
                  }, 2000)
                }
              }
            } else if (msg.type === 'execution_error') {
              console.error('❌ 执行错误:', msg.data)
              this.videoSoundChatHistory.push({
                role: 'assistant',
                content: '抱歉，似乎发生了某些问题',
                timestamp: new Date().toISOString(),
                isError: true
              })
              this.$emit('chatUpdate', this.videoSoundChatHistory)
              Message.error('视频音效生成过程中出现错误，请查看控制台')
              this.ws.close()
              this.processing = false
              this.$emit('aiTyping', false)
            }
          } catch (error) {
            console.error('WebSocket消息解析失败:', error)
          }
        }
      }
      this.ws.onclose = async () => {
        console.log('🔌 WebSocket 连接关闭')
        try {
          const index = await cudaIndexNum()
          if (index) {
            await cuda.changeCudaCurrentStatus(index, 'leisure')
          }
        } catch (error) {
          console.log(error)
        }
      }
      this.ws.onerror = (error) => {
        console.error('❌ WebSocket 错误:', error)
        Message.error('WebSocket 连接错误')
        this.processing = false
        this.$emit('aiTyping', false)
      }
    },

    // 检查任务状态
    async checkTaskStatus(promptId) {
      try {
        console.log('🔍 检查任务状态:', promptId)
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 300000,
          headers: {
            'Content-Type': 'application/json'
          }
        })
        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        console.log('📝 任务历史信息:', promptInfo)

        if (!promptInfo) {
          console.error('❌ 找不到任务信息，任务可能还在排队中...')
          return
        }

        if (promptInfo.status) {
          console.log('📊 任务状态:', promptInfo.status.status_str)
          if (promptInfo.status.status_str === 'success') {
            if (!this.fileFetched) {
              this.fileFetched = true
              await this.fetchResultVideo(promptId)
            }
          } else if (promptInfo.status.status_str === 'error') {
            console.error('❌ 任务执行失败:', promptInfo.status)
            this.videoSoundChatHistory.push({
              role: 'assistant',
              content: '抱歉，似乎发生了某些问题',
              timestamp: new Date().toISOString(),
              isError: true
            })
            this.$emit('chatUpdate', this.videoSoundChatHistory)
            Message.error('任务执行失败，请检查工作流配置')
            this.processing = false
            this.$emit('aiTyping', false)
            this.ws.close()
          }
        }
      } catch (error) {
        console.error('🚫 检查任务状态失败:', error)
      }
    },

    // 记录任务结束
    async recordTaskEnd(videoUrl) {
      try {
        const info = {
          details: [{ path: videoUrl }]
        }
        await getTaskEnd({ result: JSON.stringify(info) }, this.taskLogId)
      } catch (error) {
        console.error('记录任务结束失败:', error)
      }
    },

    // 获取结果视频URL
    async fetchResultVideo(promptId) {
      try {
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 300000,
          headers: {
            'Content-Type': 'application/json'
          }
        })
        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        console.log('📄 完整的promptInfo:', promptInfo)

        if (promptInfo.status.status_str === 'success') {
          // 视频音效工作流输出节点ID为53(VideoCombineOSS)
          const nodeId = '53'
          let videoUrl = null

          // 优先从 outputs 获取 oss_path（VideoCombineOSS节点输出格式为 gifs 数组）
          if (promptInfo.outputs && promptInfo.outputs[nodeId]) {
            const nodeOutput = promptInfo.outputs[nodeId]
            console.log(`📊 ${nodeId}号节点输出:`, nodeOutput)
            if (nodeOutput.gifs && nodeOutput.gifs.length > 0 && nodeOutput.gifs[0].oss_path) {
              const ossPath = nodeOutput.gifs[0].oss_path
              console.log('🎬 从 outputs 获取的OSS路径:', ossPath)
              videoUrl = genOssImage(ossPath)
              console.log('✅ 生成的视频URL:', videoUrl)
            }
          }

          // 兜底：从 prompt inputs 的 filename 字段获取
          if (!videoUrl) {
            console.log('⚠️ outputs 中未获取到 oss_path，尝试从 filename 字段获取...')
            const promptIndex = 2
            console.log('🔍 尝试访问路径:', `promptInfo.prompt[${promptIndex}][${nodeId}]`)

            if (!promptInfo.prompt || !promptInfo.prompt[promptIndex] || !promptInfo.prompt[promptIndex][nodeId]) {
              console.error(`历史记录结构异常，无法找到节点${nodeId}的数据`)
              this.videoSoundChatHistory.push({
                role: 'assistant',
                content: '抱歉，似乎发生了某些问题',
                timestamp: new Date().toISOString(),
                isError: true
              })
              this.$emit('chatUpdate', this.videoSoundChatHistory)
              Message.error('获取生成结果失败：历史记录结构异常')
              this.processing = false
              this.$emit('aiTyping', false)
              return
            }

            const filenameStr = promptInfo.prompt[promptIndex][nodeId].inputs.filename
            console.log('🔍 原始 filename 字符串:', filenameStr)
            const tmp = JSON.parse(filenameStr)
            console.log('✅ 解析的文件名:', tmp)
            videoUrl = genOssImage(tmp[0])
            console.log('✅ 从 filename 生成的视频URL:', videoUrl)
          }

          if (videoUrl) {
            const fileName = videoUrl.split('/').pop()
            const resultVideo = {
              name: fileName,
              url: videoUrl
            }

            // 添加AI回复到历史
            this.videoSoundChatHistory.push({
              role: 'assistant',
              content: '视频音效生成已完成，已为你生成带音效的视频～!',
              resultVideo: resultVideo,
              timestamp: new Date().toISOString()
            })
            this.$emit('chatUpdate', this.videoSoundChatHistory)
            this.$emit('aiTyping', false)
            this.processing = false
            // 记录任务结束
            await this.recordTaskEnd(videoUrl)
            Message.success('视频音效生成成功!')
          } else {
            console.error('无法获取视频URL')
            this.videoSoundChatHistory.push({
              role: 'assistant',
              content: '抱歉，似乎发生了某些问题',
              timestamp: new Date().toISOString(),
              isError: true
            })
            this.$emit('chatUpdate', this.videoSoundChatHistory)
            Message.error('获取视频结果失败')
            this.processing = false
            this.$emit('aiTyping', false)
          }
        } else {
          console.error('任务状态异常:', promptInfo.status)
          this.videoSoundChatHistory.push({
            role: 'assistant',
            content: '抱歉，似乎发生了某些问题',
            timestamp: new Date().toISOString(),
            isError: true
          })
          this.$emit('chatUpdate', this.videoSoundChatHistory)
          Message.error(`任务执行失败: ${promptInfo.status.status_str}`)
          this.processing = false
          this.$emit('aiTyping', false)
        }
      } catch (error) {
        console.error('获取视频失败：', error)
        console.error('错误详情:', error.response?.data || error.message)
        this.videoSoundChatHistory.push({
          role: 'assistant',
          content: '抱歉，似乎发生了某些问题',
          timestamp: new Date().toISOString(),
          isError: true
        })
        this.$emit('chatUpdate', this.videoSoundChatHistory)
        Message.error('获取生成结果失败，请查看控制台')
        this.processing = false
        this.$emit('aiTyping', false)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 25px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.active {
  background: @basicselect;
}

.navigation {
  position: absolute;
  width: calc(100vw - 80px);
  bottom: 15px;
  left: 100px;
  z-index: 8;
  transition: all 0.5s;

  .navigation_bottom {
    position: relative;
    width: 1536px;
    height: 50px;
    font-size: 23px;
    margin: 0 auto;
    justify-content: space-between;
    margin-bottom: 10px;

    .ai_assistant {
      position: absolute;
      bottom: -10px;
      width: 120px;
      height: 120px;
      opacity: 0;
      transition: all 0.5s;
    }

    .scroll_bottom {
      position: absolute;
      right: 0px;
      font-size: 20px;
      color: @font_white;
      background-color: #c1c1c1;
      padding: 10px 15px;
      cursor: pointer;
      border-radius: @border_radius_3;
      transition: all 0.5s;
      opacity: 0;
    }
  }

  .navigation_items {
    position: relative;
    width: 1336px;
    height: 180px;
    display: flex;
    flex-direction: column;
    background: rgba(235, 235, 235, 0.5);
    backdrop-filter: blur(10px);
    border: 1px solid @font_white;
    border-radius: @border_radius;
    transition: all 0.3s;
    margin: 0 auto;
    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);

    .main_input {
      width: 100%;
      height: 180px;
      display: flex;
      align-items: center;
      padding: 20px 20px;
      gap: 15px;

      // 视频上传区域
      .upload-section {
        position: relative;
        width: 100px;
        height: 100px;
        border: 2px dashed #d0d0d0;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s;
        flex-shrink: 0;
        overflow: hidden;
        background: white;

        &:hover {
          border-color: @morejoy;
          background: #fff8f3;
        }

        .upload-placeholder {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          height: 100%;

          .upload-plus {
            font-size: 36px;
            color: #999;
            font-weight: 300;
            line-height: 1;
          }

          .upload-label {
            font-size: 12px;
            color: #666;
            font-weight: 400;
          }
        }

        .uploaded-preview {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #000;

          .thumbnail-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .remove-btn {
            position: absolute;
            top: 5px;
            right: 5px;
            width: 20px;
            height: 20px;
            background: rgba(0, 0, 0, 0.6);
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
              background: rgba(255, 0, 0, 0.8);
              transform: scale(1.1);
            }
          }
        }
      }

      textarea {
        flex: 1;
        font-family: '微软雅黑';
        font-size: 23px;
        padding: 20px;
        border: none;
        background: none;
        resize: none;
        outline: none;
      }

      .sent {
        position: absolute;
        right: 15px;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        font-size: 35px;
        color: @font_white;
        border: none;
        border-radius: 30px;
        background-color: @font_gray;
        cursor: pointer;
        opacity: 0.7;
        transition: all 0.3s;

        &.has_input {
          background-color: @morejoy;
          opacity: 1;
        }

        &:hover:not(:disabled) {
          opacity: 1;
          font-size: 38px;
        }

        &:disabled {
          opacity: 0.3;
          cursor: not-allowed;
        }

        .rotating {
          animation: rotate 1s linear infinite;
        }
      }
    }

    /* 放大后的发送按钮（绝对定位） */
    .sent_expanded {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      width: 60px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      font-size: 35px;
      color: @font_white;
      border: none;
      border-radius: 30px;
      background-color: @font_gray;
      cursor: pointer;
      opacity: 0.7;
      transition: all 0.3s;
      z-index: 10;

      &.has_input {
        background-color: @morejoy;
        opacity: 1;
      }

      &:hover:not(:disabled) {
        opacity: 1;
        font-size: 38px;
      }

      &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }

      .rotating {
        animation: rotate 1s linear infinite;
      }
    }
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
